import React from 'react';
import { withAppLayout } from '../core/routes';
import KitsPage from './KitsPage';
import KitPage from './KitPage';
export const kitsRoutes = [
  { path: '/kits', element: withAppLayout(<KitsPage />) },
  { path: '/kit/:workspaceId/:kitId', element: <KitPage /> },
];
